<template>
    <div class="rp-scenario-breadcrumb" v-if="breadCrumbHandler">
        <div v-for="(scenario, index) in breadCrumbHandler" :key="index+'breadcrumb'">
            <span @click="breadCrumbClick(scenario, index)" :class="[ index+1 ===  breadCrumbHandler.length ? 'font-active' : 'font-inactive' ]">
                <template v-if="scenario.scenarioId === 'HOME'" >
                    <HomeImg />
                </template>
                {{ scenario.scenarioId !== 'HOME' ? scenario.scenarioName : '' }}
            </span>
            <HMargin :unit="0.3"/>
            <span class="rp-scenario-seperator" v-if="index+1 !==  breadCrumbHandler.length">
                <i class="el-icon-arrow-right"></i>
            </span>
            <HMargin :unit="0.3"/>
        </div>
    </div>
</template>

<script>
    import HomeImg from '../Images/Home';
    export default {
        props: {
            breadCrumbHandler: {
                type: Array,
                default: [],
            },
            isItFullScreen: {
                type: Boolean,
                default: false,
            }
        },

        components: {
            HomeImg
        },

        methods: {
            breadCrumbClick(scenario, index) {
                const {
                    breadCrumbHandler
                } = this;
                if(index+1 !==  breadCrumbHandler.length)
                    this.$emit('breadCrumbClick', scenario)
            }
        },
    };
</script>

<style lang="scss" scoped>
    .rp-scenario-breadcrumb {
        display: flex;
        flex-wrap: wrap;
        margin: 16px;
        width: calc(100% - 32px);

        .rp-scenario-seperator {
            font-size: 11px;
        }
        text-transform: capitalize;
        .font-active {
            font-size: 15px;
            line-height: 30px;
            color: #999999;
        }

        .font-inactive {
            font-size: 15px;
            color: #333;
            line-height: 30px;
            font-weight: 400;
            cursor: pointer;
        }
    }
</style>
